module.exports = __webpack_public_path__ + "img/background-edit.a0d58407.png";